<form [formGroup]="searchForm" class="w-100 dense-2">
    <mat-form-field appearance="outline" class="w-100 searchField" subscriptSizing="dynamic">
        <button mat-icon-button matIconSuffix (click)="onSearchClicked($event)"><mat-icon color="primary">search</mat-icon></button>
        <input matInput #inputAutoComplete type="text" placeholder="State, County, City, Zip, Address" formControlName="searchString" [matAutocomplete]="auto" #trigger="matAutocompleteTrigger" (focus)="onInputFieldClick($event)">
        <mat-autocomplete #auto="matAutocomplete" panelWidth="auto">
            @for (category of searchCategories; track category.name; let first = $first) {
                @if (category.items.length) {
                    @if (!first) { <div class="divider my-1"></div> }
                    <div class="flex-row items-center mb-1"><mat-icon class="mr-2">{{category.icon}}</mat-icon>{{category.name}}</div>
                    @for (item of category.items; track item) {
                        <mat-option class="item ml-3" [value]="item" (onSelectionChange)="onItemSelected(item, trigger, auto)">
                            <div class="flex-row space-between w-100"><div>{{item.result}}</div><div class="ml-5">{{item.resultType}}</div></div>
                        </mat-option>
                    }
                }
            }
        </mat-autocomplete>
    </mat-form-field>
</form>






